export const requestGeoLocatioPermissions = async (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  callback: (permission: boolean) => void,
) => {};
